import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { useIsLicensed } from '@confluence/session-data/entry-points/useAccessStatus.ts';
import { useIsNewUser } from '@confluence/targeting/entry-points/useIsNewUser.ts';

export type UseIsEligibleRovoAnnouncement = {
	isEligible: boolean;
	loading: boolean;
	error?: Error;
};

export const useIsEligibleRovoAnnouncement = (): UseIsEligibleRovoAnnouncement => {
	const { isRovoLLMEnabled } = useSessionData();
	const isLicensed = useIsLicensed();

	const basicEligibilityMet = isRovoLLMEnabled && isLicensed && fg('aifc_onboarding_ga_enabled');

	const {
		isNewUser,
		loading: isLoadingNewUser,
		error: errorNewUser,
	} = useIsNewUser({}, !basicEligibilityMet);

	if (isLoadingNewUser) {
		return {
			isEligible: false,
			loading: true,
		};
	}

	if (errorNewUser) {
		return {
			isEligible: false,
			loading: false,
			error: errorNewUser,
		};
	}

	// If we can't determine if user is new (isNewUser is null), treat as ineligible
	if (isNewUser === null) {
		return {
			isEligible: false,
			loading: false,
		};
	}

	return {
		isEligible: basicEligibilityMet && !isNewUser,
		loading: false,
	};
};
